import Vue2datepicker from 'vue2-datepicker'

export default {
  name: 'Datepicker',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    disabledDates: {
      type: Object,
      default: () => null
    },
    value: {
      type: Date,
      default: () => new Date()
    }
  },
  data() {
    return {
      time: null,
      lang: {
        formatLocale: {
          months: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
          monthsShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          weekdays: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
          weekdaysShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
          weekdaysMin: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
          firstDayOfWeek: 1,
          firstWeekContainsDate: 1
        }
      }
    }
  },
  components: {
    Vue2datepicker
  },
  methods: {
    onInput(event) {
      this.correctDate(event)
      this.$emit('input', event)
    },
    onPick(event) {
      if (this.disabledDates.to) {
        const dateValue = this.$moment(event)
        const dateTo = this.$moment(this.disabledDates.to)
        if (dateValue.diff(dateTo) < 0) {
          this.onInput(this.disabledDates.to)
        }
      }
    },
    onWheel(event) {
      if (event.target.closest('.mx-scrollbar-wrap')) {
        event.stopPropagation()
      }
    },
    correctDate(date) {
      date.setSeconds(0)
      date.setMilliseconds(0)
    },
    disabledDateTime(date, isDate) {
      if (this.disabledDates) {
        const zeroTimeObj = {
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }
        const dateFrom = this.$moment(this.disabledDates.from)
        const dateTo = this.$moment(this.disabledDates.to)
        const dateToZeroTime = this.$moment(this.disabledDates.to).set(zeroTimeObj)
        const dateValue = this.$moment(date)
        if (this.disabledDates.from) {
          return dateValue.diff(dateFrom) > 0
        }
        if (this.disabledDates.to) {
          if (isDate && dateValue.isSame(dateToZeroTime)) {
            return false
          }
          return dateValue.diff(dateTo) < 0
        }
      }
      return false
    },
    disabledDate(date) {
      return this.disabledDateTime(date, true)
    },
    disabledTime(date) {
      return this.disabledDateTime(date, false)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        const seconds = this.value.getSeconds()
        const milliseconds = this.value.getMilliseconds()
        if (seconds !== 0 || milliseconds !== 0) {
          const correctedDate = new Date(this.value)
          this.correctDate(correctedDate)
          this.onInput(correctedDate)
        }
      }
    }
  }
}